import React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency } from '../../utils/formatters';

/**
 * AtRiskBand
 * Red-tinted band surfacing up to 3 projects that need follow-up:
 * have an active payment notice AND still have money outstanding.
 *
 * Renders nothing when rows is empty so the page stays calm.
 *
 * Props:
 *   rows: project row objects (caller is responsible for filtering + sorting)
 */
export default function AtRiskBand({ rows }) {
  if (!rows || rows.length === 0) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
      <div className="flex items-center gap-2 mb-3">
        <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-red-500 text-white text-xs font-bold">!</span>
        <h3 className="text-sm font-semibold text-red-900">Needs attention</h3>
        <span className="text-xs text-red-700">
          {rows.length} project{rows.length > 1 ? 's' : ''} with an active notice
        </span>
      </div>
      <ul className="space-y-2">
        {rows.map(r => (
          <li
            key={r.projectId}
            className="flex items-center justify-between gap-3 bg-white rounded-md border border-red-100 px-3 py-2"
          >
            <div className="min-w-0 flex-1">
              {r.siteDatabaseId ? (
                <Link
                  to={`/sites/${r.siteDatabaseId}`}
                  className="text-sm font-medium text-blue-600 hover:underline"
                >
                  {r.projectNumber}
                </Link>
              ) : (
                <span className="text-sm font-medium text-gray-900">{r.projectNumber}</span>
              )}
              <span className="text-xs text-gray-500 ml-2 truncate">{r.clientName || '—'}</span>
            </div>
            <div className="text-right shrink-0">
              <div className="text-xs text-gray-500">Notice</div>
              <div className="text-sm font-semibold text-red-700 tabular-nums">
                {formatCurrency(r.noticeIssuedAmount)}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
